export default __webpack_public_path__ + "static/avatar-5e778bec7b8ac87ccdf2dff424c7129f.png";